import React, { FC, ReactNode, useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ErrorsSelector, removeError } from 'store/errors';
import { enqueueSnackbar } from 'notistack';

interface IProps {
  children: ReactNode;
}

const ErrorProvider: FC<IProps> = ({ children }) => {
  const errors = useAppSelector(ErrorsSelector);
  const dispatch = useAppDispatch();

  const handleDeleteError = useCallback(
    (id: number) => {
      dispatch(removeError(id));
    },
    [dispatch],
  );

  useEffect(() => {
    if (errors.length) {
      errors.forEach((e): void => {
        enqueueSnackbar(e.message, { variant: 'error' });
        handleDeleteError(e.id);
      });
    }
  }, [errors]);

  return <>{children}</>;
};

export default ErrorProvider;
